import type { paths } from "../../api/generated/api-types";

export type PublicationFilter = NonNullable<
  paths["/publications"]["post"]["requestBody"]["content"]["application/json"]["filter"]
>;

// PUB-01 «Параметры системного автозапуска»: filter.* values the pipeline substitutes
// when task.publicationParams is absent; the manual launch form opens with the same
// values (TaskDetail «Форма запуска публикации»).
export const PUBLICATION_FILTER_DEFAULTS: PublicationFilter = {
  dr: 1,
  organicKeywords: 0,
  age: 0,
  uniqueSites: true,
  regions: null,
  includeSecondary: true,
  includeSubdomains: false,
};
